import { render } from "./FileGroup.vue?vue&type=template&id=70fc8a42&scoped=true"
import script from "./FileGroup.vue?vue&type=script&lang=js"
export * from "./FileGroup.vue?vue&type=script&lang=js"

import "./FileGroup.vue?vue&type=style&index=0&id=70fc8a42&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fc8a42"]])

export default __exports__